import React, { useState } from "react";
import "./style.scss";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SignupForm from "../../../components/Auth/SignupForm";

const Signup = ({ mode }) => {
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  return (
    <div className="signup-container">
      {/* <ErrorModal/> */}
      <div className="signup-left-wrapper">
        <div className="signup-left-form">
          <SignupForm  mode = {mode}/>
        </div>
      </div>
      <div className="signup-right-wrapper">
        <div className="signup-right-authframe">
          <AuthFrame />
        </div>
      </div>
    </div>
  );
};

export default Signup;
